import * as React from 'react';

interface IProps {
    className?: string;
}

export const BaseLandholdC: React.FC<IProps> = ({ className }) => (
    <svg
        className={className}
        viewBox="0 0 76 77"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g
            id="designs"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <path
                d="M38.02,61.571 C25.28,61.571 14.915,51.13 14.915,38.297 C14.915,25.464 25.28,15.023 38.02,15.023 C48.065,15.023 56.629,21.516 59.805,30.552 L75.258,30.552 C71.693,13.135 56.351,0 38.02,0 C17.056,0 0,17.18 0,38.297 C0,59.415 17.056,76.594 38.02,76.594 C56.399,76.594 71.771,63.39 75.284,45.904 L59.851,45.904 C56.714,55.012 48.116,61.571 38.02,61.571"
                id="Fill-1"
                fill="#010202"
            />
        </g>
    </svg>
);
